import { Container, Typography } from "@mui/material";
import React from "react";
import { styled } from "styled-components";
import theme, { COLORS } from "ui/theme";

type HeaderProps = {
  title: string;
};

const HeaderElement = styled.header({
  background: `linear-gradient(261.59deg, ${COLORS.lightIndigo} -6.6%, ${COLORS.indigo} 79.03%);`,
  padding: "1.25rem 0 0",
  [theme.breakpoints.up("md")]: {
    padding: "3rem 0 0",
  },
  [theme.breakpoints.up("lg")]: {
    padding: "5.5rem 0 0.75rem",
  },
});

export const Header: React.FC<HeaderProps> = ({ title }) => {
  return (
    <>
      <HeaderElement>
        <Container>
          <Typography variant="h1">{title}</Typography>
        </Container>
      </HeaderElement>
    </>
  );
};
